// extracted by mini-css-extract-plugin
export default {"container":"PersistenceRadioGroup_container__g0Xw3","text":"PersistenceRadioGroup_text__4PmGT"};